import React, { useEffect, useState } from "react";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import RoundedDropdown from "../../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { useLocation } from "react-router-dom";
import { useOutletInventory, useUpdateOutletInventory } from "./hooks/useCustomer";

const HeaderContent = (props: any) => {
  const handleFilter = (key: any, selected: any) => {
    props?.setFiltersState((prev: any) => ({
      ...prev,
      [key]: selected.id == "null" ? null : Number(selected.id),
    }));
  };

  return (
    <div
      style={{
        marginBottom: "15px",
        display: "flex",
        justifyContent: "flex-start",
        gap: "10px",
        alignItems: "center",
      }}
    >
      <RoundedDropdown
        options={props?.orgUnitsList || []}
        onSelect={(e) => {
          handleFilter("orgUnits", e);
        }}
        defaultLabel="All"
        width="auto"
        height="25px"
        isShowHeading
        DropdownHeading="Organization"
        headingColor="#2e8dd3"
      />
    </div>
  );
};

// const dataforInventory = [
//   {
//     TagName: "Sample",
//     Product:"Titanic | 280 | 140",
//     Free:0,
//     Reversed:0,
//     Blocked_Damaged:0
//   },
//   {
//     TagName: "Sample",
//     Product:"Azhitomicen | 1000 | nil",
//     Free: 0,
//     Reversed: 0,
//     Blocked_Damaged: 0
//   },
//   {
//     TagName: "Sample",
//     Product:"Eye Drop | 2366378423 | Packed",
//     Free:0,
//     Reversed:0,
//     Blocked_Damaged:0
//   },
//   {
//     TagName: "Sample",
//     Product:"Gestofit 100mg | 50002179 | Handle with care",
//     Free:0,
//     Reversed:0,
//     Blocked_Damaged:0
//   },
//   {
//     TagName: "Sample",
//     Product:"Gestofit inj100mgml | 500002182 | Handle with care",
//     Free:0,
//     Reversed:0,
//     Blocked_Damaged:0
//   },
// ];

const InventroyScreen: React.FC = () => {
  const [filtersState, setFiltersState] = useState<any>({ Category: null });
       const [pageState, setPageState] = useState({
     page: 1,
   });
   const [limitState, setLimitState] = useState({
     limit: 10,
   });
  const [editingCell, setEditingCell] = useState<{
    rowIndex: number;
    field: string;
  } | null>(null);
  const [editedRowIds, setEditedRowIds] = useState<Set<number>>(new Set());

  const [data, setData] = useState<any>();

  const location = useLocation();
  console.log("location", location.state);

  const { data: getInventoryList } = useOutletInventory({
    enabled: !!location.state.OutletID,
    params: {
      orgUnitId: location.state.inventory.OrgUnitId,
      page:pageState.page,
      limit:limitState.limit
    },
    id: location.state.OutletID,
  });
  console.log("inventorylist", getInventoryList?.data?.OutletStock);

  useEffect(() => {
    if (getInventoryList?.data?.OutletStock) {
      setData([...getInventoryList.data.OutletStock]);
    }
  }, [getInventoryList]);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
    field: "ReservedQty" | "FreeQty" | "BsdQty"
  ) => {
    const updatedRows = [...data];
    updatedRows[index][field] = Number(e.target.value);
    setData(updatedRows);

    const productId = updatedRows[index].ProductId; // ✅ correct case

    setEditedRowIds((prev) => {
      const newSet = new Set(prev);
      newSet.add(productId);
      return newSet;
    });
  };

  const editableCell = (
    row: any,
    rowIndex: number,
    field: "ReservedQty" | "FreeQty" | "BsdQty"
  ) => {
    const isEditing =
      editingCell?.rowIndex === rowIndex && editingCell?.field === field;

    if (isEditing) {
      return (
        <input
          type="number"
          value={row[field]}
          autoFocus
          onBlur={() => setEditingCell(null)}
          onChange={(e) => handleInputChange(e, rowIndex, field)}
          onKeyDown={(e) => {
            if (e.key === "Enter") setEditingCell(null);
          }}
          style={{ width: "70px" }}
        />
      );
    }

    return (
      <div
        onClick={() => setEditingCell({ rowIndex, field })}
        style={{ cursor: "pointer" }}
      >
        {row[field]||'0'}
      </div>
    );
  };

  const classificationColums = () => [
    {
      name: "Category",
      selector: (row: { Category: number | string }) => row.Category,
    },
    {
      name: "Product",
      selector: (row: { ProductName: string }) => row.ProductName,
      wrap: true,
    },
    {
      name: "Free",
      cell: (row: any, index: number) => editableCell(row, index, "FreeQty"),
    },
    {
      name: "Reversed",
      cell: (row: any, index: number) =>
        editableCell(row, index, "ReservedQty"),
    },
    {
      name: "Blocked/Damaged",
      cell: (row: any, index: number) => editableCell(row, index, "BsdQty"),
    },
  ];


  const {mutate:updateInventory}=useUpdateOutletInventory()

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setPageState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
 
      };
  });
      setLimitState((prevState: any) => {
        return {
          ...prevState,
          limit: limit,
        };
      });
    
  };
  const handlePagination = (pageNo: number) => {
    setPageState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  }

  return (
    <div className="container-fluid mt-3">
      <PageHeader
        title={
          `${location.state?.inventory?.OutletName}` +
          " | " +
          `${location.state.OutletID}`
        }
        buttons={[
          {
            label: "Save Changes",
 onClick: () => {
  const updatedRows = data.filter((row: any) =>
    editedRowIds.has(row.ProductId)
  );

  const payload:any = {
    id: location.state.OutletID, // path param
    body: {
      orgUnitId:location.state.inventory.OrgUnitId,
      outletStocks: updatedRows.map((row: any) => ({
        outletStocktId: row.OutletStockId,
        productId: row.ProductId,
        bsdQty: row.BsdQty,
        freeQty: row.FreeQty,
        reservedQty: row.ReservedQty,
        closingQty: row.ClosingQty,
      })),
    },
  };

  console.log("Formatted Payload:", payload);

  // 🔥 Send the payload to API
  updateInventory(payload);
},
            color: "#43B9B2",
          },
        ]}
      />
      <div>
        <BasicDataTable
        paginationTotalRows={getInventoryList?.data?.Pagination?.TotalOutletStock}
          Title="Inventory"
          data={data || []}
          columns={classificationColums()}
          // headerContent={
          //   <HeaderContent />
          // }
          onChangePage={(pageNo: number) => {
             handlePagination(pageNo);
           }}
          onChangeRowsPerPage={(newPerPage: any, page: any) => {
           handleonChangeRowsPerPage(newPerPage, page);
         }}
        />
      </div>
    </div>
  );
};
export default InventroyScreen;
